import { render } from "./ThePagination.vue?vue&type=template&id=455cc612&ts=true"
import script from "./ThePagination.vue?vue&type=script&lang=ts"
export * from "./ThePagination.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src3346310468/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__